import { Card, List } from 'antd';
import { FormattedMessage } from 'react-intl';

interface CooperativesProps {
  cooperatives: cyrian.api.cooperatives.Cooperative[];
}

export const Cooperatives = ({ cooperatives }: CooperativesProps) => {
  const list = cooperatives ?? [];
  const isEmpty = list.length === 0;

  return (
    <Card
      className="card-shadow"
      title={<FormattedMessage id="counterparties.cooperative.title" />}
      bordered={false}
      size="small"
    >
      {isEmpty ? '—' : <List dataSource={list} renderItem={(item) => <List.Item>{item.name}</List.Item>} />}
    </Card>
  );
};
